import React, { useEffect } from 'react';
import { InformationUpdate, navigate } from '@teliaee/crm-components';
import { Separator } from 'telia-front-react';
import LoggingApi from '../api/LoggingApi';
export const InformationUpdatePageOld = () => {
    useEffect(() => {
        LoggingApi.postLog(location.pathname);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
        React.createElement(InformationUpdate, { onSave: () => navigate('/konto') }),
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" })));
};
